export var LiquidationPreferenceType;
(function (LiquidationPreferenceType) {
    LiquidationPreferenceType["None"] = "none";
    LiquidationPreferenceType["NonParticipating"] = "nonParticipating";
})(LiquidationPreferenceType || (LiquidationPreferenceType = {}));
export var AntiDilutionRights;
(function (AntiDilutionRights) {
    AntiDilutionRights["NarrowBased"] = "narrowBased";
    AntiDilutionRights["None"] = "none";
})(AntiDilutionRights || (AntiDilutionRights = {}));
export var CouponType;
(function (CouponType) {
    CouponType["Cash"] = "cash";
    CouponType["None"] = "none";
})(CouponType || (CouponType = {}));
export var MonitoringRights;
(function (MonitoringRights) {
    MonitoringRights["ObserverRights"] = "observerRights";
    MonitoringRights["None"] = "none";
})(MonitoringRights || (MonitoringRights = {}));
export var HoldingClassType;
(function (HoldingClassType) {
    HoldingClassType["Common"] = "common";
    HoldingClassType["Preferred"] = "preferred";
})(HoldingClassType || (HoldingClassType = {}));
//# sourceMappingURL=index.js.map